// eslint-disable-next-line import/extensions
import axios from 'axios';
import store from '../store';
import router from '../router';

export default function defaultFetch(options) {
  return new Promise((resolve) => {
    const instance = axios.create({
      timeout: 20000, // 超时
    });
    instance(options)
      .then((response) => {
        const res = response.data;
        if (res.code === 1200) {
          resolve(res);
        }
        if (response.data.code === 16003 || response.data.code === '16003') {
          store.commit('del_token');
          router.push({ path: '/login' });
        }
      })
      .catch((error) => {
        resolve(error);
      });
  });
}

export function fetchPassword(options) {
  return new Promise((resolve) => {
    const instance = axios.create({
      timeout: 20000, // 超时
      headers: {
        Token: store.state.token,
      },
    });
    instance(options)
      .then((response) => {
        if (response.data.code === 16003 || response.data.code === '16003') {
          store.commit('del_token');
        }
        const res = response.data;
        resolve(res);
      })
      .catch((error) => {
        resolve(error);
      });
  });
}

export function fetch(options) {
  return new Promise((resolve) => {
    const instance = axios.create({
      timeout: 20000, // 超时
      headers: {
        Token: store.state.token,
      },
    });
    instance(options)
      .then((response) => {
        if (response.data.code === 16003 || response.data.code === '16003') {
          store.commit('del_token');
          router.push({ path: '/login' });
        } else {
          const res = response.data;
          resolve(res);
        }
      })
      .catch((error) => {
        resolve(error);
      });
  });
}

export function fetchFile(options) {
  return new Promise((resolve) => {
    const instance = axios.create({
      timeout: 20000, // 超时
      headers: {
        Token: store.state.token,
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
    instance(options)
      .then((response) => {
        if (response.data.code === '1004' || response.data.code === '1005') {
          store.commit('del_token');
          router.push({ path: '/login' });
        } else {
          const res = response.data;
          resolve(res);
        }
      })
      .catch((error) => {
        resolve(error);
      });
  });
}
